
              const Handlebars = require('handlebars');
              const templateFunction = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  return "<header>\n	<a href=\"/\">\n		<img src=\"/8269b65f1c1647897d00326e452deef2.png\" alt=\"Infoxchange Service Seeker\" class=\"logo-img\">\n	</a>\n</header>\n";
  },"useData":true});
              Handlebars.templates['src/hbs/partials/mobile_logo_bar.hbs'] = templateFunction;
              export default templateFunction;
              